import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatDatepicker} from '@angular/material/datepicker';
import { LOCALE_ID } from '@angular/core';
import localeIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';

@Component({
  selector: 'app-data-range',
  templateUrl: './data-range.component.html',
  styleUrls: ['./data-range.component.scss']
})
export class DataRangeComponent implements OnInit {
  @Input() title: string = null;
  @Input() start: Date;
  @Input() end: Date;
  @Output() selectedRange: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('startDatePicker') startDatePicker: MatDatepicker<Date>;
  @ViewChild('endDatePicker') endDatePicker: MatDatepicker<Date>;
  showDate: string = null;

  constructor() {}

  ngOnInit(): void {
    registerLocaleData(localeIt, 'it-IT');
  }

  setStartDate(e): void {
    console.log(e);
    this.start = e;
    this.checkRange();
    this.showDate = 'end';
    // this.endDatePicker.open();
  }

  setEndDate(e): void {
    console.log(e);
    this.showDate = null;
    this.end = e;
    this.checkRange();
  }

  checkRange(): void {
    if (this.end && this.start) {
      if (this.start <= this.end) {
        const out = {start: this.start, end: this.end};
        this.selectedRange.emit(out);
      }
    }
  }

}
